
import {
  reactive, ref, watch, defineComponent, computed,
} from 'vue';
import moment,{ Moment, } from 'moment';
import {
  Modal, Select, DatePicker, TreeSelect, message,
} from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { postDownload, } from '@/request/request';

const { Option, } = Select;
const { RangePicker, } = DatePicker;

export default defineComponent({
  components: {
    TreeSelect,
    Select,
    Modal,
    Option,
    RangePicker,
  },
  props: {
    downloadVisible: {
      type: Boolean,
      default: () => false,
      require: true,
    },
    stationList: {
      type: Array,
      default: () => [],
      require: true,
    },
    stations: {
      type: Array,
      default: () => [],
      require: true,
    },
  },
  setup (props: { stations: any; stationList: any; }, { emit, }: any) {
    interface FormState {
      timeSize: string | undefined;
      rangeTime: any | undefined;
      stations: any | undefined;
    }
    const timeList = [
      {
        value: 'year',
        name: '年',
      },
      {
        value: 'month',
        name: '月',
      },
      {
        value: 'day',
        name: '日',
      },
      {
        value: 'hour',
        name: '时',
      },
      {
        value: 'minute',
        name: '分',
      },
    ];

    const resetData = () => ({
      timeSize: 'hour',
      rangeTime: [],
      stations: props.stations,
    });
    const cstationList = ref<any>([]);
    const Form = reactive<FormState>({
      timeSize: 'hour',
      rangeTime: [],
      stations: [],
    });

    // 范围日期格式
    const rangeFormat = ref<string>('YYYY-MM-DD HH:[00]');
    // 日期格式参数格式
    const paramFormat = ref<string>('YYYYMMDDHH');
    // 范围选择器模式
    const rangeMode = ref<any>(['date','date',]);
    // 是否可选时间
    const isShowTime = ref<boolean>(true);
    // 时间格式
    const timeFormat = ref<string>('HH');
    // 限制时间 时:7天 天: 30天 月: 12月
    const limitNum = ref<number>(30);
    // 限制单位 天:days 月:months
    const limitUnit = ref<any>('days');
    // 限制格式
    const limitFormat = ref<string>('YYYY-MM-DD');
    // 是否下载中
    const isDownload = ref<boolean>(false);

    // 是否只选择了微站
    const istOnlyMicro = computed(() => {
      let flag = false;
      const val = Form.stations;

      if (!val || val.length === 0) return flag;
      const microStations = cstationList.value.find((item:any) => item.type === 3);
      const idx = val.findIndex((name:string) => microStations?.children?.findIndex((item:any) => item.value === name) < 0);

      flag = idx < 0;

      return flag;
    });

    /**
     * @method handleSelect
     * @param {any} value 类型
     * @param {string} type 类型
     * @return {void} 切换
     */
    const handleSelect = (value: any, type: string): void => {
      Form[type] = value;

      if (type === 'timeSize') {
        switch (value) {
        case 'year':
          rangeFormat.value = 'YYYY';
          rangeMode.value = ['year','year',];
          paramFormat.value = 'YYYY';
          isShowTime.value = false;
          break;
        case 'month':
          rangeFormat.value = 'YYYY-MM';
          rangeMode.value = ['month','month',];
          isShowTime.value = false;
          limitNum.value = 12;
          limitUnit.value = 'months';
          limitFormat.value = 'YYYY-MM';
          paramFormat.value = 'YYYYMM';
          break;
        case 'day':
          rangeFormat.value = 'YYYY-MM-DD';
          rangeMode.value = ['date','date',];
          isShowTime.value = false;
          limitNum.value = 30;
          limitUnit.value = 'days';
          limitFormat.value = 'YYYY-MM-DD';
          paramFormat.value = 'YYYYMMDD';
          break;
        case 'hour':
          rangeFormat.value = 'YYYY-MM-DD HH:[00]';
          rangeMode.value = ['date','date',];
          isShowTime.value = true;
          timeFormat.value = 'HH';
          limitNum.value = 3;
          limitUnit.value = 'months';
          limitFormat.value = 'YYYY-MM-DD';
          paramFormat.value = 'YYYYMMDDHH';
          break;
        case 'minute':
          rangeFormat.value = 'YYYY-MM-DD HH:mm';
          rangeMode.value = ['date','date',];
          isShowTime.value = true;
          timeFormat.value = 'HH:mm';
          limitNum.value = 7;
          limitUnit.value = 'days';
          limitFormat.value = 'YYYY-MM-DD';
          paramFormat.value = 'YYYYMMDDHHmm';
          break;
        default:
          break;
        }

        return;
      }

      if (!istOnlyMicro.value && Form.timeSize === 'minute') {
        // 未选择微站，时间粒度为分钟时，自动切换为小时
        Form.timeSize = 'hour';
        Form.rangeTime = [];
        handleSelect('hour', 'timeSize');
      }
    };

    const handleCalendarChange = (value:any):void => {
      Form.rangeTime = value;
    };

    /**
     * 日期面板改变
     * @param {*} value 值
     * @param {*} type 类型
     * @return {void}
     */
    const handlePanelChange = (value:any, type:string): void => {
      Form.rangeTime = value;
    };

    /**
     * 日期范围
     * @param {*} current 当前选择时间
     * @return {void}
     */
    const disabledDate = (current:any):any => {
      if (!Form.rangeTime || Form.rangeTime.length === 0) {
        return moment(current).format(limitFormat.value).valueOf() > moment().format(limitFormat.value).valueOf();
      }
      const diffDate1 = moment(current).diff(Form.rangeTime[0], limitUnit.value);
      const diffDate2 = moment().diff(Form.rangeTime[0], limitUnit.value);

      if (diffDate2 < limitNum.value) {
        return diffDate1 < 0 || diffDate1 > diffDate2;
      }

      return diffDate1 < 0 || diffDate1 >= limitNum.value;
    };

    const range = (start:any, end:any) => {
      const temp = [];

      for (let i = start; i < end; i++) {
        temp.push(i);
      }

      return temp;
    };

    /**
     * 时间范围
     * @param {*} _ 当前选择时间
     * @param {*} type 前后
     * @return {any} 时间
     */
    const disabledTime = (_: Moment[], type: string): any => {
      if (!Form.rangeTime || Form.rangeTime.length === 0) {
        return {
          disabledHours: () => [],
        };
      }

      if (type === 'start') {
        return {
          disabledHours: () => range(0, Form.rangeTime[0].hour()),
        };
      }

      return {
        disabledHours: () => {
          if (Form.rangeTime[0].format('YYYY-MM-DD').valueOf() === moment().format('YYYY-MM-DD').valueOf()) {
            return range(moment().hour(), 24);
          }

          return range(Form.rangeTime[0].hour() + 1, 24);
        },
      };
    };

    const handleCancle = ():void => {
      emit('cancal');
      Object.assign(Form, resetData());
      handleSelect('hour', 'timeSize');
    };

    const handleDownload = () => {
      if (isDownload.value) {
        return;
      }

      if (!Form.rangeTime.length) {
        message.warn('未选择时间段');

        return;
      }

      isDownload.value = true;
      // 文件名
      const name = `${Form.rangeTime[0].format(paramFormat.value)}-${Form.rangeTime[1].format(paramFormat.value)}所选站点时间粒度${Form.timeSize}历史数据`;

      const params = {
        startTime: Form.rangeTime[0].format(paramFormat.value),
        endTime: Form.rangeTime[1].format(paramFormat.value),
        type: Form.timeSize,
        nameList: Form.stations.length > 0 ?
          Form.stations :
          [],
      };

      postDownload(`/analyze/downloadByStandardStation`, params, name).then(() => {
        isDownload.value = false;
        emit('save');
        Object.assign(Form, resetData());
        handleSelect('hour', 'timeSize');
      }).catch(() => {
        isDownload.value = false;
        message.error('下载失败');
      });
    };

    watch(() => props.stationList, (val) => {
      cstationList.value = val;
      Form.stations = props.stations;
    },{
      deep: true,
    });

    return {
      locale,
      timeList,
      props,
      cstationList,
      Form,
      rangeFormat,
      paramFormat,
      rangeMode,
      isShowTime,
      timeFormat,
      limitNum,
      limitUnit,
      limitFormat,
      isDownload,
      istOnlyMicro,
      handleSelect,
      handleCalendarChange,
      handlePanelChange,
      disabledDate,
      disabledTime,
      handleCancle,
      handleDownload,
    };
  },
});
